import { FaChevronLeft } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";

interface ButtonProps {
    title?: string;
    suffix?: React.ReactNode;
    onClick?: () => void;
    backgroundColor?: string;
}

const CustomAppBar: React.FC<ButtonProps> = ({ title, suffix, onClick,  backgroundColor="transparent" }) => {
    const navigate = useNavigate();
    return (
        <div>
            <div className="flex flex-col items-center w-full" style={{ backgroundColor: backgroundColor }}>
                <div className="absolute top-3 left-4">
                    <button className="text-2xl" onClick={onClick ? onClick : () => navigate(-1)}>
                        <FaChevronLeft className="size-5" />
                    </button>
                </div>
                <h1 className="text-lg font-bold absolute top-3">{title}</h1>
                <div className="absolute top-3 right-4">
                    {suffix}
                </div>
            </div>
        </div>
    );
};

export default CustomAppBar;